import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {RoutesEnum} from "@dropDesk/domain/entities/routes/routes_enum";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import React from "react";
import {useNavigate} from "react-router-dom";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";

const ButtonNewTicket = observer(
    ({}: {}) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const navigate = useNavigate();

        return (
            <ButtonNew
                marginLeft={0}
                label={'Novo Atendimento'}
                onClick={() => navigate(`${RoutesEnum.tickets}/${ConstantsKeys.isNewRegister}`)}
                sizeLeftIcon={16}
                disabled={false}
                isButtonMain={true}
            />
        )
    })
export default ButtonNewTicket;
